<template>
	<div class="friends">
		<div class="container">
			<h3 :style="{ color: parceiro ? parceiroConfig.estilo.corPrimaria : '#003e6c' }">Conheça nossos parceiros</h3>
			<p v-if="parceiro && parceiroConfig.sessoes.partners.campos">
				{{ parceiroConfig.sessoes.partners.campos.text }}
			</p>
			<p v-else>Conheça os parceiros que acreditam e confiam no Acerteaqui Autonegociação.</p>
			<div v-if="!parceiro" class="friends-row">
				<img src="../../../assets/images/parceiros/logo-clinipam.jpg" alt="logo clinipam" />
				<img src="../../../assets/images/parceiros/logo-cred-jb.jpg" alt="logo cred jb" />
				<img src="../../../assets/images/parceiros/logo-dentaluni.jpg" alt="logo dentaluni" />
				<img src="../../../assets/images/parceiros/logo_fastalways_transparente.png" alt="logo fastalways" />
				<img src="../../../assets/images/parceiros/logo_hipercob.png" alt="logo hipercob" />
				<img src="../../../assets/images/parceiros/logo_maxipas_1.png" alt="logo maxipas" />
				<img src="../../../assets/images/parceiros/logo_nacional.png" alt="logo nacional" />
				<img src="../../../assets/images/parceiros/logo_tercred.png" alt="logo tercred" />
				<img src="../../../assets/images/parceiros/solut.png" alt="logo solut" />
			</div>
			<div class="friends-row" v-else-if="parceiroConfig && imgs_par.length > 0">
				<img class="logo-parceiro" v-for="parc in imgs_par" :src="parc.arquivo" :key="parc.id" alt="parceiro" />
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex"

export default {
	name: "LandPagePartner",
	data() {
		return {
			imgs_par: []
		}
	},
	computed: {
		...mapState({
			parceiro: state => state.parceiro,
			parceiroConfig: state => state.parceiroConfig
		})
	},
	created() {
		this.imgs_par = []
		if (this.parceiroConfig && this.parceiroConfig.sessoes.partners.arquivos.length > 0) {
			this.imgs_par = this.parceiroConfig.sessoes.partners.arquivos
		}
	}
}
</script>

<style scoped lang="scss">
.container {
	padding-top: 90px;
	padding-bottom: 90px;
	background-color: var(--lightGrayColor);
	h3 {
		text-align: center;
		font-size: 32px;
		font-family: "Montserrat-Bold";
		color: var(--whiteColor);
		line-height: 48px;
		margin-bottom: 30px;
	}
	p {
		text-align: center;
	}
}

.friends-row {
	text-align: center;
}

.logo-parceiro {
	background-color: white;
	margin: 30px;
	@media only screen and (max-width: 766px) {
		margin: 30px 10px;
	}
	height: 86px;
	border-radius: 20px;
	padding: 8px 16px;
}
</style>
